<template>
  <div class="etx-container Container" :class="paragraphClassList">
    <div class="etx-center Center">

      <div class="etx-flex Flex tab-s:gv-0">

        <div class="etx-flex__item Flex__item tab-s:c-0 show-0 tab-s:show-1">

          <div class="BrandshapeWrapper falling-off-left desk-l:falling-off-max-left" :class="entranceClassList">

            <div class="Brandshape" :data-color-main="stripeColorMain" :data-color-accent="stripeColorAccent">
              <svg width="208" height="208">
                <use :xlink:href="stripeShape"></use>
              </svg>
            </div>

          </div>

        </div>

        <div class="etx-flex__item Flex__item tab-s:c-10 tab-m:c-9 tab-l:c-7 tab-s:ml-2 tab-m:ml-3 tab-l:ml-4">

          <NuxtPageDependency>
            <Breadcrumb :isEditing="isEditing" :links="breadcrumb" v-if="showBreadcrumb"/>
          </NuxtPageDependency>

          <div class="etx-text Text" :class="entranceClassList">
            <h2 v-if="heading && headingType == 'h2'" :class="[headingStyle !== 'standard' ? headingStyle : '', {'font-color-secondary': lead}]" >{{ heading }}</h2>
            <h3 v-if="heading && headingType == 'h3'" :class="[headingStyle !== 'standard' ? headingStyle : '', {'font-color-secondary': lead}]" >{{ heading }}</h3>
            <h4 v-if="heading && headingType == 'h4'" :class="[headingStyle !== 'standard' ? headingStyle : '', {'font-color-secondary': lead}]" >{{ heading }}</h4>
            <p v-if="lead" v-html="lead.replace(/\n/g, '<br>')" class="font-lead"></p>
            <HelperHtmlRenderer :htmlContent="text"/>
          </div>

          <!-- <LoaderSwiper /> -->
          <BlokkliProxyMode :isEditing="isEditing" fieldName="field_logos" :elements="logos" />
          <div v-if="logos.length > 0" class="swiper Swiper SwiperLogos small" :class="entranceClassList" :data-swiper-id="sliderId">

            <div class="swiper-wrapper Swiper__wrapper">
              <div v-for="logo in logos" class="swiper-slide Swiper__wrapper__slide">

                <a v-if="logo?.link"
                  class="etx-media Media"
                  :href="logo?.link?.domainUri?.path || logo?.link?.uri?.path"
                  :title="logo?.icon?.alt?.alt"
                  :target="logo?.link?.targetBlank ? '_blank' : '_self'"
                >
                  <picture>
                    <MediaIcon :media="logo?.icon" />
                  </picture>
                </a>

                <div class="etx-media Media" v-else>
                  <picture>
                    <MediaIcon :media="logo?.icon" />
                  </picture>
                </div>

              </div>

            </div>

          </div>


          <BlokkliProxyMode :isEditing="isEditing" fieldName="field_link_elements_rev" :elements="buttons" />
          <div class="etx-button-list ButtonList" :class="entranceClassList" v-if="buttons.length > 0">
            <Button v-for="button in buttons"
              :type="button?.type"
              :targetBlank="button?.targetBlank"
              :href="button?.link?.domainUri?.path || button?.link?.uri?.path"
              :label="button?.label"
              :alt="button?.alt"
            />
          </div>

          <BlokkliProxyMode :isEditing="isEditing" fieldName="field_accordion_elements_rev" :elements="accordion" />
          <div class="etx-accordion-list AccordionList" v-if="accordion.length > 0">

            <div class="etx-accordion-list AccordionList">

              <div v-for="accordionElement in accordion" class="etx-accordion Accordion" :class="entranceClassList">

                <div class="etx-accordion__header Accordion__header">

                  <div class="etx-accordion__header__title Accordion__header__title" data-accordion-clickable="">
                    <p>{{ accordionElement.heading }}<span class="font-weight-regular font-color-primary" v-if="accordionElement.headingSubline">{{ accordionElement.headingSubline }}</span></p>
                  </div>

                  <div class="etx-accordion__header__button Accordion__header__button" data-accordion-clickable="">
                    <i class="far fa-plus"></i>
                  </div>

                </div>

                <div class="etx-accordion__content Accordion__content">

                  <div class="etx-text Text font-color-medium" v-if="accordionElement.text">
                    <p v-if="accordionElement.lead" class="font-lead" v-html="accordionElement.lead.replace(/\n/g, '<br>')"></p>
                    <HelperHtmlRenderer :htmlContent="accordionElement.text"/>
                  </div>

                  <div class="etx-button-list ButtonList" v-if="accordionElement.buttons.length > 0">
                    <Button v-for="button in accordionElement.buttons"
                      :type="button?.type"
                      :targetBlank="button?.targetBlank"
                      :href="button?.link?.domainUri?.path || button?.link?.uri?.path"
                      :label="button?.label"
                      :alt="button?.alt"
                    />
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  </div>
</template>

<script lang="ts" setup>

const props = defineProps<{
  showBreadcrumb: boolean
  heading?: string
  headingType: string
  headingStyle: string
  lead?: string
  text?: string
  buttons: Array<any>
  accordion: Array<any>
  stripe: string
  logos: Array<any>
  sliderId: string
}>()

const breadcrumb = useBreadcrumbLinks()

const { options, isEditing } = defineBlokkli({
  bundle: 'text_1_col_stripe',
  globalOptions: ['spacingTop', 'spacingBottom', 'backgroundColor'],
})

const paragraphClassList = computed(() => {

  const classList = []

  if (options.value.spacingTop) {
    classList.push(options.value.spacingTop)
  }

  if (options.value.spacingBottom) {
    classList.push(options.value.spacingBottom)
  }

  if (options.value.backgroundColor !== 'white') {
    classList.push(options.value.backgroundColor)
  }

  return classList
})

const entranceClassList = computed(() => {
  const classList = []
  if (!isEditing) {
    classList.push('will-appear', 'move-up')
  }
  return classList
})

const stripeShape = computed(() => {
  return '#brandshape-' + props.stripe.split('_')[0]
})

const stripeColorMain = computed(() => {
  return props.stripe.split('_')[1]
})

const stripeColorAccent = computed(() => {
  return props.stripe.split('_')[2]
})


</script>
